export default [{
  path: '/meeting/index',
  name: 'meeting',
  component: resolve => require(['./index.vue'], resolve)
}
]



// WEBPACK FOOTER //
// ./src/views/meeting/router.js